import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "../locales/en.json";
import vi from "../locales/vi.json";
import zh from "../locales/zh.json";

/**
 * Three languages wired up so far: English (the app's original language -
 * every string not yet moved into this system still renders in English
 * regardless of locale, since it's still hardcoded JSX elsewhere),
 * Vietnamese, and Chinese (Simplified) - all three currently cover the
 * same surface: the wallet feature (balance, send/request/split, tab,
 * history, blocklist, notifications) and core navigation chrome (the chat
 * list header, common actions). Anything else in the app - posts, stories,
 * admin dashboard, moderation, and most settings screens - hasn't been
 * extracted into translation keys yet. Extending coverage means finding
 * the hardcoded string in its component, adding a key to all three locale
 * files, and swapping the JSX to `t("that.key")` - this file and the
 * locale JSON files are the only things that need touching to add more.
 *
 * Initial language for a first-time visitor (no stored preference yet) is
 * suggested by useLanguageAutoDetect.ts based on where the request appears
 * to originate from (Vietnam -> vi, China -> zh, everywhere else -> en) -
 * see that hook and the backend's /api/geo/language endpoint for how.
 * Once a person has ever explicitly picked a language (the toggle in
 * Settings), that choice is what's stored in localStorage and nothing
 * overrides it again, including a later auto-detect check.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi },
      zh: { translation: zh }
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false }, // React already escapes - double-escaping would corrupt e.g. "&" in names
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "kaventine_language"
    }
  });

export default i18n;
